import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi, setAdminToken, getAdminToken } from "./adminApi";

const AdminAuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);     // user obj or null
  const [checking, setChecking] = useState(true);

  const verify = useCallback(async () => {
    if (!getAdminToken()) { setAdmin(null); setChecking(false); return; }
    try {
      const { data } = await adminApi.get("/admin/me");
      setAdmin(data);
    } catch {
      setAdminToken(null);
      setAdmin(null);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { verify(); }, [verify]);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/admin/login", { email, password });
    setAdminToken(data.token);
    await verify();
    return data;
  };

  const logout = async () => {
    try { await adminApi.post("/admin/logout"); } catch {}
    setAdminToken(null);
    setAdmin(null);
  };

  return (
    <AdminAuthCtx.Provider value={{ admin, checking, login, logout }}>
      {children}
    </AdminAuthCtx.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthCtx);
